<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        编辑{{ seriesName }}预案
      </div>
    </div>
    <div class="ml20 mt20 f18 blue">
      <i class="el-icon-back cursor" @click="$router.back()"> 返回</i>
    </div>
    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
    <div class="flex center ml20">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="mt20"
        style="width: 100%"
      >
        <h2 class="center">{{ seriesName }}灭火和应急疏散预案</h2>

        <el-row :gutter="24" class="mt20">
          <el-col :span="24">
            <!-- 引言 -->
            <el-row>
              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>一、引言</h2>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="introduction">
                    <el-input
                      v-model="form.introduction"
                      type="textarea"
                      :rows="6"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item
                    prop="drillName"
                    label-width="100px"
                    :label="`预案名称`"
                  >
                    <el-input v-model="form.drillName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
            <el-row class="center">
              <el-col :span="16">
                <el-form-item
                  label-width="100px"
                  prop="drillTower"
                  :label="`预案区域`"
                >
                  <!-- <el-input v-model="form.drill_tower"></el-input> -->
                  <el-select
                    v-model="form.drillTower"
                    placeholder="请选择"
                    @change="changetower($event, true)"
                  >
                    <el-option
                      v-for="item in units"
                      :key="item.tower"
                      :label="item.tower"
                      :value="item.tower"
                      >{{ item.tower }}</el-option
                    >
                  </el-select>

                  <el-select
                    v-model="form.drillTier"
                    placeholder="请选择"
                    filterable
                    @change="changetier($event, 1)"
                  >
                    <el-option
                      v-for="item in select2"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 概述 -->
            <el-row :gutter="20">
              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>二、概述</h2>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="summary">
                    <el-input
                      v-model="form.summary"
                      type="textarea"
                      :rows="6"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 主要内容 -->
              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>三、主要内容</h2>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="compilationPurpose">
                    <template>
                      <span class="jiacu">3.1 编制目的</span></template
                    >
                    <el-input
                      v-model="form.compilationPurpose"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="compilationBasis">
                    <template>
                      <span class="jiacu">3.2 编制依据</span></template
                    >
                    <el-input
                      v-model="form.compilationBasis"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="applicableScope">
                    <template>
                      <span class="jiacu">3.3 适用范围</span></template
                    >
                    <el-input
                      v-model="form.applicableScope"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="workPrinciples">
                    <template>
                      <span class="jiacu">3.4 应急工作原则</span></template
                    >
                    <el-input
                      v-model="form.workPrinciples"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <div style="display:flex">
                    <span class="jiacu">3.5 单位基本情况</span>

                    <el-checkbox-group
                      style="margin-left:30px;margin-top:3px"
                      v-model="baseSituationCheck"
                      @change="changeBaseSituationCheck"
                    >
                      <el-checkbox :label="1">生产加工企业</el-checkbox>
                      <el-checkbox :label="2">涉及危险化学品</el-checkbox>
                    </el-checkbox-group>
                  </div>

                  <el-form-item
                    prop="prodSituationCheck"
                    label="生产加工企业情况"
                    v-if="baseSituationCheck.indexOf(1) > -1"
                  >
                    <el-input
                      v-model="form.prodSituationCheck"
                      type="textarea"
                      :rows="2"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="chemicalSituationCheck"
                    label="危险化学品情况"
                    v-if="baseSituationCheck.indexOf(2) > -1"
                  >
                    <el-input
                      v-model="form.chemicalSituationCheck"
                      type="textarea"
                      :rows="2"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="baseJibenqk"
                    label="3.5.1 单位基本情况介绍"
                  >
                    <el-row class="mt20">
                      <el-col>
                        {{ form.baseJibenqk }}
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row> </el-row>
              <el-row class="center mt20">
                <el-col :span="16" style="display:flex;flex-wrap:wrap">
                  <el-form-item
                    :prop="item.value"
                    :label="item.name"
                    v-for="(item, index) in uploadImag"
                    style="margin:10px"
                  >
                    <el-upload
                      ref="fileUploadBtn"
                      class="avatar-uploader"
                      :http-request="(params) => upload(params, index)"
                      accept="*"
                      action="."
                      :show-file-list="false"
                      :disabled="item.uploadFlag"
                      v-if="item.picOrpdf == 'img'"
                    >
                      <el-image
                        v-if="item.value && item.picOrpdf == 'img'"
                        :src="item.value"
                        class="avatar"
                        :preview-src-list="[uploadImag[index].value]"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-link
                      v-if="item.picOrpdf == 'pdf'"
                      :href="`${uploadImag[index].value}`"
                      :underline="false"
                      target="_blank"
                    >
                      <span class="el-icon-document"
                        >{{ uploadImag[index].name }}
                      </span>
                    </el-link>
                    <div class="ele-upload-list__item-content-action">
                      <div class="editDel">
                        <span v-if="uploadImag[index].file">{{
                          uploadImag[index].file.name
                        }}</span>
                        <el-link
                          :underline="false"
                          @click="handleDelete(index)"
                          type="danger"
                          >删除</el-link
                        >
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item
                    prop="fireSituation"
                    label="3.5.8 火灾危险源情况"
                  >
                    <el-input
                      v-model="form.fireSituation"
                      type="textarea"
                      placeholder="例：主要危险源有地下车库、空调机房、配电室等重要设施设备机房，公司耗材仓库、会议室等人员密集场所(每一个火灾危险源位置、性质和可能发生的事故，危险源区域的操作人员和防护手段，可燃物品仓储位置、形式和数量等)。"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item
                    prop="xiaofangSheshi"
                    label="3.5.9 单位消防设施情况"
                  >
                    <el-row class="mt20">
                      <el-col>
                        {{ form.xiaofangSheshi }}
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item
                    prop="prodSituation  "
                    label="3.5.10 生产相关情况"
                  >
                    <el-input
                      v-model="form.prodSituation"
                      type="textarea"
                      placeholder=""
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="prodSituation  " label="3.5.11 化危品情况">
                    <el-input
                      v-model="form.chemicalSituation"
                      type="textarea"
                      placeholder=""
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="workPrinciples">
                    <template>
                      <span class="jiacu">3.6 火灾情况设定</span></template
                    >
                    <el-input
                      v-model="form.fireSituationSet"
                      placeholder="例：假定大厦厨房发生火灾。
厨房发生火灾事故各种情况，包括常见引火源、可燃物的性质、事故可能危及范围、爆炸可能性、燃气泄漏可能性以及火灾蔓延可能性等内容；对预案组织实施产生不良影响的因素、客观条件等应考虑到位(餐厅、耗材仓库、会议室、地下车库、空调机房、配电室等重要设施设备机房、部位均为火灾易发部位)。
火灾事故蔓延扩大的因素以及影响人员疏散的情况。
在大风、雷电、暴雨、高温、严寒等恶劣天气下对经营、消防设施设备以及火灾扑救、人员疏散造成的影响，应采取的针对性措施等。"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="compilationBasis">
                    <template>
                      <span class="jiacu">3.7 组织机构及职责</span></template
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                class="center mt20"
                style="display:flex;flex-direction:column"
              >
                <el-col :span="16">
                  <el-form-item label-width="100px" label="参加人员">
                    <el-row class="flex">
                      <el-col :span="10">
                        <ul>
                          <li v-for="(item, index) in groupList" :key="index">
                            <el-button
                              class="ml10 mt10 perbutton"
                              v-if="item.id != 9 && item.id != 10"
                              :type="
                                item.child && item.child.length
                                  ? 'primary'
                                  : 'info'
                              "
                              size="small"
                              plain
                              @click="selectgroup(item, index)"
                              >{{ item.name }}
                            </el-button>
                          </li>
                        </ul>
                      </el-col>
                      <div class="ml20 mt20" style="min-width:800px">
                        <!-- 职责穿梭框 -->
                        <el-transfer
                          v-model="transferValue"
                          :data="transferData"
                          filterable
                          filter-placeholder="请输入名字"
                          :filter-method="filterMethod"
                          :titles="[transferLeftName, '人员库']"
                          @change="handleChange"
                        >
                          <el-select
                            class="transfer-footer"
                            slot="left-footer"
                            v-model="selectPerson.tower"
                            placeholder="请选择组长"
                            filterable
                            @focus="selectFocus"
                            @change="changeSelecttower($event, true, true)"
                          >
                            <el-option
                              v-for="item in groupLeader"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label"
                            ></el-option>
                          </el-select>
                        </el-transfer>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label-width="100px" label="选择指挥">
                    <el-row class="flex">
                      <el-col :span="10" style="width:140px">
                        <el-select
                          v-model="commanderChiefSelectvalue"
                          placeholder="总指挥"
                          @change="changeCommanderChief($event)"
                        >
                          <el-option
                            v-for="item in commanderChiefSelect"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row class="flex">
                      <el-col :span="10" style="width:140px">
                        <el-select
                          v-model="commanderChiefDeputyvalue"
                          placeholder="副总指挥"
                          @change="changeCommanderChiefDeputy($event)"
                        >
                          <el-option
                            v-for="item in commanderChiefDeputySelect"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <!-- <el-form-item style="width:140px">
                    
                  </el-form-item> -->
                </el-col>
              </el-row>
              <!-- <canvas ref="screenshotCanvas"> -->

              <el-row class="center mt20" >
                <el-col :span="16" id="screenshot" style="display:flex;justify-content:center;">
                  <vue2-org-tree
                    :data="treeData"
                    :render-content="renderContent"
                  />
                </el-col>
              </el-row>
              <!-- </canvas> -->

              <el-row>
                <!-- <Screenshot></Screenshot> -->
              </el-row>
              <!-- 职责文本 -->
              <el-row class="center">
                <el-col :span="16">
                  <el-form-item label="各组职责">
                    <div class="duty mt10">
                      <p>
                        （1）火场指挥组：由消防安全管理人负责总指挥，消防安全归口管理部门负责人协助。火场指挥组主要负责根据方便现场指挥、通信联络、保证自身安全的原则，指挥协调各职能小组和遗物消防队开展工作，根据火情决定是否通知人员疏散并组织实施，及时控制和扑救火灾。公安消防队到达后，及时向指挥员报告火场内的有关情况，按照指挥员的统一部署，协调配合公安消防队开展灭火救援行动。
                      </p>

                      <p>
                        （2）通信联络组：由现场工作人员及消防控制室值班人员组成，负责操作消防自动控制系统，并与指挥机构和当地消防部门、区域联防单位及其他应急行动涉及人员的通信、联络；
                      </p>
                      <p>
                        （3）灭火行动组：由自动消防系统操作员、专兼职消防员组成，负责在发生火灾后立即利用消防设施、器材扑救初起火灾；
                      </p>
                      <p>
                        （4）疏散引导组：由指定的一线岗位人员和专兼职消防员组成，负责引导人员正确疏散、逃生，清点人员并逐级上报；
                      </p>

                      <p>
                        （5）防护救护组：由指定的具有基础医护知识的人员组成，负责抢救、护送受伤人员；
                      </p>

                      <p>
                        （6）安全保卫组：由单位安保人员组成，负责阻止与场所无关人员进入现场，保障消防疏散通道和消防车通道畅通，消防扑救场地无障碍物，保护火灾现场，协助消防部门开展火灾调查；
                      </p>
                      <p>
                        （7）后勤保障组：由相关物资保管人员组成，负责抢险物资、器材器具的供应及后勤保障。
                      </p>
                      <p>
                        （8）机动组：受火场指挥组的指挥，负责增援行动和其他临时任务。
                      </p>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="emergencyResp">
                    <template>
                      <span class="jiacu">3.8 应急响应</span></template
                    >
                    <el-input
                      v-model="form.emergencyResp"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="emergencySupport">
                    <template>
                      <span class="jiacu">3.9 应急保障</span></template
                    >
                    <el-input
                      v-model="form.emergencySupport"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>四、附件</h2>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16" style="display:flex">
                  <div>
                    <el-upload
                      accept="*"
                      action="."
                      :show-file-list="false"
                      :http-request="annexUpload"
                      list-type="picture-card"
                    >
                      <!-- :file-list="fileList1" -->
                      <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <div>可最多上传5个视频、图片格式</div>
                  </div>
                  <div style="display:flex;flex-wrap:wrap">
                    <div v-for="(item, index) in fileList1">
                      <el-image
                        style="width:150px;height:150px;margin:5px"
                        v-if="item.type == 'img'"
                        class="el-upload-list__item-thumbnail"
                        :src="item.value"
                        alt=""
                        :preview-src-list="[item.value]"
                      />
                      <video
                        style="width:150px;height:150px;margin:5px"
                        v-else
                        class="el-upload-list__item-thumbnail"
                        :src="item.value"
                        controls="controls"
                      ></video>
                      <div
                        style="color:red;cursor:pointer"
                        @click="deleteAnnex(item, index)"
                        type="danger"
                      >
                        删除
                      </div>
                    </div>
                  </div>

                  <!-- </el-col> -->
                  <!-- </el-form-item>slot="file" slot-scope="{ file }" -->
                </el-col>
              </el-row>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="60%">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <div class="btn-box center">
      <el-button
        type="primary"
        @click="onSubmit()"
        :loading="btnLoading"
        class="ml20"
        v-hasPermi="['plan:plan:addOrUpdateInfo']"
        >保存</el-button
      >
      <el-button
        type="success"
        class="ml20"
        v-if="this.$route.query.id"
        v-hasPermi="['plan:plan:planExportWord']"
        @click="downLoad()"
        >导出</el-button
      >
      <el-button
        type="primary"
        class="ml20"
        @click="onSubmit(1)"
        v-hasPermi="['plan:plan:planSaveSync']"
        v-if="$route.query.id"
        :loading="btnLoading"
        >保存并同步</el-button
      >
      <el-button type="primary" @click="$router.back()" class="ml20"
        >返回</el-button
      >
    </div>
    <el-backtop target=".common-body-style"></el-backtop>
  </div>
</template>

<script>
import { getSafeList } from "../../api/safety";
import OSS from "ali-oss";
import { login } from "../../api/common";
import config from '@/utils/config';
import axios from 'axios'
// import Screenshot from "@/components/Screenshot";
import html2canvas from "html2canvas";
// import transfer from "../../components/transfer";
var baseUrl = null
const mimeMap = {
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}
if (process.env.NODE_ENV === 'development') { //本地
  baseUrl = config.apiUrltest

} else if (process.env.NODE_ENV === 'production') { //线上
  baseUrl = config.apiUrl
}
export default {
  // components: { Screenshot },
  inject: ["reload"],
  data() {
    return {
      transferData: [],
      transferCopyData: [],
      transferValue: [],
      id: this.$route.query.id || null,
      c_num:
        this.$route.query.c_num || this.$store.state.user.company.cCompanyNum,
      series: this.$route.query.series,
      seriesName: "",
      groupName: "er",
      groupList: [
        {
          id: 8,
          key: "communicationLiaisonGroup",
          name: "通信联络组",
          child: "",
        },
        {
          id: 7,
          key: "evacuationEscapeGroup",
          name: "疏散逃生组",
          child: "",
        },
        {
          id: 3,
          key: "evacuationGuidanceGroup",
          name: "疏散引导组",
          child: "",
        },
        {
          id: 1,
          key: "fireCommandGroup",
          name: "火场指挥组",
          child: "",
        },
        {
          id: 2,
          key: "fireFightActionGroup",
          name: "灭火行动组",
          child: "",
        },
        {
          id: 6,
          key: "logisticsSupportGroup",
          name: "后勤保障组",
          child: "",
        },
        {
          id: 4,
          key: "protectionRescueGroup",
          name: "防护救护组",
          child: "",
        },
        {
          id: 5,
          key: "securityGroup",
          name: "安全保卫组",
          child: "",
        },
        {
          id: 9,
          key: "commanderChief",
          name: "总指挥",
          child: "",
        },
        {
          id: 10,
          key: "commanderChiefDeputy",
          name: "副总指挥",
          child: "",
        },
      ], // 所有组别
      commanderChiefSelect: [], //总指挥下拉
      commanderChiefSelectvalue: "", //总指挥值
      commanderChiefDeputySelect: [], //副总指挥下拉
      commanderChiefDeputyvalue: "", //副总指挥值

      selectedPeople: [], // 已选择的人员
      compOption: [], // 人员库
      btnLoading: false,
      units: [],
      select2: [],
      dialogVisible: false,
      dialogImageUrl: "", // 预览图片url
      form: {
        baseJibenqk: "",
        xiaofangSheshi: "",
        alarmRecord: "",
        applicableScope: "",
        attachment: "",
        introduction:
          "为了保护火灾发生时人员的生命和财产安全，最大限度地减少人员伤亡和财产损失，根据《消防法》61号令的精神，按照《社会单位灭火和应急疏散预案编制及实施导则》（GB/T 38315-2019）要求，特制定此灭火和应急疏散预案。",
        baseSituationCheck: "",
        chemicalSituation: "",
        chemicalSituationCheck: "",
        companyNum:
          this.$route.query.c_num || this.$store.state.user.company.cCompanyNum,
        compilationBasis: "",
        compilationPurpose: "",
        drillImage: "",
        drillName: "",
        drillPerson: {},
        drillStatus: 2,
        drillSummary: "",
        drillTime: "",
        drillTower: "",
        drillUuid: "",
        drillZongjie: "",
        elevationsImg: "",
        emergencyResp:
          "二级预案应明确由消防安全管理人到场指挥，拨打“119”报告二级火警，调单位志愿消防队、微型消防站和专业消防力量到场处置，组织疏散人员、扑救初起火灾抢救伤员、保护财产，控制火势扩大蔓延。",
        emergencySupport:
          "1. 通信与信息保障，制定信息通信系统及维护方案，保障有 24 h 有效的报警装置和有效的内部、外部通信联络手段，确保应急期间信息通畅。\n2. 应急队伍保障，完善应急组织机构管理机制，制定每日值班表，保障应急工作需要\n3. 物资装备保障，整理单位应急物资和装备的类型、数量、性能、存放位置、运输及使用条件、管理责任人及其联系方式等内容\n4.其他保障，整理经费保障、治安保障、技术保障、后勤保障及其他应急工作需求的相关保障措施。",
        exerciseArea: "",
        exerciseImg: "",
        exerciseRecordUuid: "",
        exerciseSummaryName: "",
        exerciseSummaryPosition: "",
        fireLocation: "",
        fireRecord: "",
        fireSituation: "",
        fireSituationSet: "",
        fireThing: "",
        fireTime: "",
        generalImg: "",
        id: this.$route.query.id || null,
        miehuoImage: "",
        miehuoNeirong: "",
        neibuPhone: "",
        personRecord: "",
        planChooseUuid: "",
        prodSituation: "",
        prodSituationCheck: "",
        qihuoFangxiang: "",
        qufenQijian: "",
        sectionImg: "",
        status: "",
        summary: "",
        weihaiHouguo: "",
        workPrinciples: "",
        xiaofangPeibei: "",
        xiaofangSheshi: "",
        xiaofangZhongdian: "",
        xiaokongPhone: "",
        zhuyhaoQihuo: "",
      },
      selectPerson: {
        tower: [1, 2, 3],
        tier: "全部",
      },
      rules: {
        plan_choose_uuid: [
          { required: true, message: "请选择预案", trigger: "blur" },
        ],
        drillTower: [
          { required: true, message: "请选择预案", trigger: "blur" },
        ],
        drillTier: [{ required: true, message: "请选择预案", trigger: "blur" }],
        drillName: [
          { required: true, message: "请填写预案名称", trigger: "blur" },
        ],
      },
      fileList1: [],
      baseSituationCheck: [],
      uploadImag: [
        {
          name: "3.5.2 总平面图",
          value: "",
          key: "generalImg",
          picOrpdf: "img",
          uploadFlag: false,
        },
        {
          name: "3.5.3 演练部位平面图",
          value: "",
          key: "exerciseImg",
          picOrpdf: "img",
          uploadFlag: false,
        },
        {
          name: "3.5.4 立面图",
          value: "",
          key: "elevationsImg",
          picOrpdf: "img",
          uploadFlag: false,
        },
        {
          name: "3.5.5 剖面图",
          value: "",
          key: "sectionImg",
          picOrpdf: "img",
          uploadFlag: false,
        },
        {
          name: "3.5.6 水泵房等消防设施位置图",
          value: "",
          key: "facilitiesImg",
          picOrpdf: "img",
          uploadFlag: false,
        },
        {
          name: "3.5.7 首层平面图",
          value: "",
          key: "floorImg",
          picOrpdf: "img",
          uploadFlag: false,
        },
      ],
      transferLeftName: "",
      selectgroupIndex: 0,
      assignedPersonData: {},
      groupLeader: "",
      treeData: {
        id: 1,
        label: "总指挥",
        // children: [
        //   {
        //     id: 2,
        //     label: "副总指挥",
        //     children: [],
        //   },
        // ],
      },
    };
  },
  computed: {},

  created() {
    //   预案名称、区域数据
    this.planArea();

    // 获取各个组，8个组，两个指挥
    this.$post("/planDrill/planDrill/assignedPerson", {
      companyNum: this.c_num,
      id: this.id,
    }).then((res) => {
      console.log(res, 777777777);
      this.assignedPersonData = res.data;
      // 把各个组的东西插进去
      for (const key in res.data) {
        this.groupList.forEach((item, index) => {
          if (key == item.key) {
            this.groupList[index].child = res.data[key];
          }
        });
      }

      //   树结构
      //   第一层
      let firstTreeRoup = JSON.parse(JSON.stringify(this.groupList)).splice(
        8,
        1
      );
      firstTreeRoup.forEach((item, index) => {
        if (item.child) {
          this.treeData.label = "总指挥";
          this.treeData.name = item.child[0].name || "";
          this.treeData.children = [];
          this.treeData.phone = item.child[0].phone || "";
          // 总指挥回显
          this.commanderChiefSelectvalue = this.treeData.name;
        }
      });

      //   第er层
      let secondTreeRoup = JSON.parse(JSON.stringify(this.groupList)).splice(
        9,
        1
      );
      secondTreeRoup.forEach((item, index) => {
        if (item.child) {
          this.treeData.children[0] = {
            label: item.name || "",
            name: item.child[0].name || "",
            phone: item.child[0].phone || "",
            children: [],
          };
          console.log(item.child);
          this.commanderChiefDeputyvalue = item.child[0].name;
        } else {
          this.treeData.children = [
            {
              label: item.name || "",

              children: [],
            },
          ];
        }
      });
      //   log(this.treeData,33333333333333)
      //  三四层别的地方还要用
      // 获取树结构
      this.setTree();
    });
    //   编辑时指挥赋值

    // 指挥
    this.$get(
      "/planDrill/planDrill/assignedPersonByCompanyAll/" + this.c_num
    ).then((res) => {
      // console.log(res, 44444444444);
      this.commanderChiefSelect = res.data; //总指挥
      this.commanderChiefDeputySelect = res.data; //副总指挥
    });

    this.getAllPeople(); //所有人
    this.transferLeftName = "请先选择小组";
    //   编辑回显
    if (this.id) {
      this.$get("/planDrill/planDrill/planManagementInfo/" + this.id).then(
        (res) => {
          console.log(res, "编辑的总数据");
          this.form = res.data;
          if (this.form.prodSituationCheck) {
            this.baseSituationCheck.push(1);
          }
          if (this.form.chemicalSituationCheck) {
            this.baseSituationCheck.push(2);
          }

          // 6个图重新赋值一下
          this.uploadImag.forEach((item, index) => {
            for (let k in this.form) {
              if (item.key == k) {
                if (this.form[k]) {
                  if (this.form[k].toLowerCase().indexOf("pdf") > -1) {
                    item.picOrpdf = "pdf";
                    item.value = this.form[k];
                  } else {
                    item.value = this.form[k];
                  }
                }
                // console.log(item,6);
              }
            }
          });
          // 附件的文件也重新搞一下
          let annex = this.form.attachment.split(",");
          this.fileList1 = annex.map((item, index) => {
            if (item.indexOf("mp4") > -1) {
              return {
                type: "video",
                value: item || "",
              };
            } else {
              return {
                type: "img",
                value: item || "",
              };
            }
          });
          // console.log(this.form.attachment, this.fileList1, "fujian");
        }
      );
    }
    //  if (this.id) {
    //     console.log(this.groupList,11111111);

    //     let data = this.groupList.filter((item) =>
    //       item.key.includes("commanderChief")
    //     );
    //     console.log(data[0].child,11111111111);
    //     if (data[0].child || data[1].child) {
    //     console.log("指挥");

    //       this.commanderChiefSelectvalue = data[0].child[0].name;
    //       this.commanderChiefDeputyvalue = data[1].child[0].name;
    //     }
    //     console.log(this.commanderChiefSelectvalue,this.commanderChiefDeputyvalue, 99999);

    //   }
    //单位基本情况、消防设施情况
    this.$get("/planDrill/planDrill/iotCompanyInformation/" + this.c_num).then(
      (res) => {
        this.form.baseJibenqk = res.data.basicInformation;
        this.form.xiaofangSheshi = res.data.fireInformation;
        console.log(this.form, 1111111);
      }
    );
  },
  mounted() {
    log(this.$route.query.series,'this.$route.query.series111111')
    if (this.$route.query.series == 1) {
      this.seriesName = "一级";
      this.form.planType=1
    } else if (this.$route.query.series == 2) {
      this.seriesName = "二级";
      this.form.planType=2
    } else if (this.$route.query.series == 3) {
      this.seriesName = "三级";
      this.form.planType=3
    }
    this.form.emergencyResp=`"${this.seriesName}预案应明确由消防安全管理人到场指挥，拨打“119”报告${this.seriesName}火警，调单位志愿消防队、微型消防站和专业消防力量到场处置，组织疏散人员、扑救初起火灾抢救伤员、保护财产，控制火势扩大蔓延。"`
        
  },

  methods: {
   getToken() {
  return localStorage.getItem('token')
},
    //   树结构
    setTree() {
      // 第三层组的，且把组长弄上去
      let threeTreeRoup = JSON.parse(JSON.stringify(this.groupList)).splice(
        0,
        8
      );
      //   console.log(threeTreeRoup, "threeTreeRoup");

      let data = threeTreeRoup.map((item, index) => {
        //   console.log(item);
        if (item.child && item.child.length > 0) {
          let header;
          let tel;
          //   console.log(item);
          item.child.forEach((i, t) => {
            if (i.teamLeader == 1) {
              // console.log(i, 11111111111);
              if (i.name) {
                header = "组长：" + i.name;
              }
              if (i.label) {
                if (i.label.indexOf("固定职责")) {
                  i.label = i.label.replace("(固定职责)", "");
                }
                header = "组长：" + i.label;
              }

              tel = i.phone;
            }
          });
          return {
            label: item.name || "",
            name: header || "",
            children: [],
            phone: tel || "",
          };
        }
      });
      //   console.log(data.filter((item) => item), 22);
      this.treeData.children[0].children = data.filter((item) => item);
      //   四层及以下，组员，与第三层关联
      let fourTreeRoup = JSON.parse(JSON.stringify(this.groupList)).splice(
        0,
        8
      );

      let teamMembers = fourTreeRoup.map((item, index) => {
        if (item.child) {
          this.treeData.children[0].children.forEach((i, t) => {
            if (i.label == item.name) {
              let a = item.child.filter((it) => it.teamLeader == 0);
              //    递归插数据
                console.log(a,66666666666);
              const insertChildren = function(parent, idx) {
                if (parent.name && !parent.label) {
                  // console.log(parent, 222222222222);
                  parent.label = "组员";
                  a[idx].label = "组员";
                }
                // else
                // 这里面第一项拿不到，弄个中间值
                let flag;
                if (a[idx].label && !a[idx].name) {
                  // log("11111111111", parent);
                  //   a[0].name = parent.label
                  //   a[0].label = "组员";
                  //  parent.name=parent.label
                  a[idx].name = a[idx].label;
                  a[idx].label = "组员";
                  //   parent.label='组员'
                }

                // console.log(11111111111111);
                parent.children = [a[idx]];
              };
              a.forEach((g, r) => {
                if (r + 1 < a.length) {
                  insertChildren(g, r + 1);
                }
              });
                console.log(a,8888888888888);
              if (a.length == 1) {
                log("jinlaile");
                if (a[0].name && !a[0].label) {
                  a[0].label = "组员";
                } else {
                  a[0].name = a[0].label;
                  a[0].label = "组员";
                }
              }
              if (a.length > 1) {
                if (a[0].label && !a[0].name) {
                  a[0].name = a[0].label;
                  a[0].label = "组员";
                }
              }
              // console.log(a[0],444444);
              if (a[0]) {
                this.treeData.children[0].children[t].children = [
                  JSON.parse(JSON.stringify(a[0])),
                ];
              }

                console.log(
                    t,
                  this.treeData.children[0].children,
                  a[0],
                  3333
                );
            }
          });
          //    console.log(item,this.treeData.children[0].children);
        }
      });
      console.log(this.treeData, 1111111111111);
      //   console.log(this.treeData);
      this.$delete(this.treeData);
      this.$set(this.treeData);
    },
    renderContent(h, data) {
      //   console.log(data, 1111111111111);
      return (
        <div>
          <div>
            <i class="el-icon-user-solid"></i>
            <span>{data.label}</span>
          </div>
          <div style="font-size:12px;line-height:20px;">
            <span>{data.name}</span>
          </div>
          <div style="font-size:12px;line-height:20px;">
            <span>{data.phone}</span>
          </div>
        </div>
      );
    },
    //   总指挥
    changeCommanderChief(val) {
      let data = this.commanderChiefSelect.filter((item) =>
        item.name.includes(val)
      );
      this.groupList.forEach((item, index) => {
        if (item.id == 9) {
          this.groupList[index].child = data;
        }
      });
      //   tree结构加入名字，总指挥在第一层id=1时
      //    this.treeData.name =data[0].name
      this.treeData.name = data[0].name;
      this.treeData.phone = data[0].phone;
      this.$delete(this.treeData);
      this.$set(this.treeData);
      //   console.log(this.treeData);
    },
    //   副总指挥
    changeCommanderChiefDeputy(val) {
      log(val);
      let data = this.commanderChiefDeputySelect.filter((item) =>
        item.name.includes(val)
      );
      this.groupList.forEach((item, index) => {
        if (item.id == 10) {
          this.groupList[index].child = data;
        }
      });

      //   tree结构加入名字，总指挥在第er层id=2时
      this.treeData.children[0].name = data[0].name;
      this.treeData.children[0].phone = data[0].phone;
      this.$delete(this.treeData);
      //   this.$set(this.treeData);
      this.$set(this.treeData);
    },
    //   穿梭框相关
    // 左侧小组按钮
    changeSelecttower(val) {
      // 选组长teamLeader,数据插入
      //   console.log(val, this.groupLeader, 666666);
      let Groupname = val;
      //   if (val.indexOf("固定职责")) {
      //     Groupname = val.replace("(固定职责)", "");
      //   }
      this.groupLeader.forEach((item, index) => {
        //       if (item.label.indexOf("固定职责")) {
        //     item.label = item.label.replace("(固定职责)", "");
        //   }
        if (item.label == Groupname) {
          console.log(item);
          item.teamLeader = 1;
        } else if (item.name == Groupname) {
          console.log(2);
          item.teamLeader = 1;
        } else {
          item.teamLeader = 0;
        }
      });
      console.log(this.groupLeader);
      this.groupList.forEach((item, index) => {
        if (item.name == this.transferLeftName) {
          item.child = this.groupLeader;
        }
      });
      //   console.log(val, this.groupList);
      //   设置树的各个组长

      this.setTree();
    },
    // 聚焦更换选组长数据
    selectFocus() {
      this.groupLeader = this.transferData.filter(
        (it) => !this.transferCopyData.includes(it)
      );
      console.log(this.groupLeader);
    },
    // 组的按钮
    selectgroup(item, index) {
      console.log(item, 1111);
      //   console.log(item, index);

      this.transferLeftName = item.name;
      this.selectgroupIndex = index;
      //   切换组的时候组长数据清空一下
      this.selectPerson.tower = "";
      //   if (this.groupLeader && this.groupList[index].child) {
      console.log(this.groupList[index].child, "meijinlai");
      if (this.groupList[index].child) {
        this.groupList[index].child.forEach((item, index) => {
          if (item.teamLeader == 1) {
            this.selectPerson.tower = item.label || item.name;
          }
        });
      }

      //   }

      this.generateData(item);
    },
    // 左右数据改变
    handleChange(value, direction, movedKeys) {
      // console.log(movedKeys,'movedKeys');
      if (this.transferLeftName == "请先选择小组") {
        this.$message.warning("请先选择小组");
        this.transferValue = this.transferValue.concat(movedKeys);
        return;
      }
      let data = this.transferData.filter(
        (item) => !this.transferValue.includes(item.key)
      );
      console.log(data,9999);

      //   console.log(this.selectgroupIndex, data);
      this.groupList[this.selectgroupIndex].child = data;
      //   console.log(this.groupList, "this.groupList");
      this.transferCopyData = this.transferData.filter((it) => {
        if (it.teamLeader==1) {
        console.log('需要');
        it.teamLeader=0
        this.selectPerson={
        tower: "",
        tier: "全部",
      }
      }
        if (this.transferValue.includes(it.key)) {
          it.label = it.label.replace("(固定职责)", "");
          return true;
        }
        if (
          this.groupList[this.selectgroupIndex].id == it.organization &&
          it.label.indexOf("(固定职责)") == -1
        ) {
          it.label = it.label + "(固定职责)";
        }
        
        return false;
      });
      if (this.transferCopyData[0]) {
        
      }
      
      console.log(this.groupList,this.transferCopyData, "youmeiy");
      this.setTree();
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    // 穿梭框左侧数据栏
    generateData(item) {
      //   console.log(item, 2222);
      //   log(item.child);
      if (item.child == null) {
        this.transferData = [...this.transferCopyData];
        return;
      }
      if (item.child === "") {
        this.transferLeftName = "请先选择小组";
        return;
      }
      let tmp = [];

      let data = item.child.map((i, index) => {
        // console.log(item,i);
        let res = {
          key: i.id || i.key,
          label: i.name || i.label,
          organization: i.organization,
          teamLeader: i.teamLeader || 0,
          phone: i.phone,
        };
        // console.log(res, 2222);
        if (i.organization == item.id) {
          if (res.label.indexOf("(固定职责)") > -1) {
          } else {
            res.label = res.label + "(固定职责)";
          }
        }
        tmp.push(res.key);
        return res;
      });
      this.transferData = [...this.transferCopyData, ...data];
      console.log(this.transferData, "init ");
      let _tmp = [];
      this.transferData.filter((it) => {
        if (!tmp.includes(it.key)) {
          _tmp.push(it.key);
        }
      });
      this.transferValue = _tmp;
      //   console.log(this.transferData, data, this.transferValue, 4444);
    },

    // 图片、pdf相关
    handleDelete(index) {
      this.uploadImag[index].value = "";
      this.uploadImag[index].picOrpdf = "img";
      this.uploadImag[index].file = "";
      this.uploadImag[index].uploadFlag = false;
      for (const key in this.form) {
        if (key == this.uploadImag[index].key) {
          this.form[key] = this.uploadImag[index].value;
        }
      }
    },
    upload(val, index) {
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.uploadImag[index].file = val.file;
      if (val.file.type.indexOf("image") > -1) {
        this.uploadImag[index].picOrpdf = "img";
      } else if (val.file.type.indexOf("pdf") > -1) {
        this.uploadImag[index].picOrpdf = "pdf";
      }

      if (
        !(
          val.file.name.toLowerCase().indexOf("pdf") > -1 ||
          val.file.name.toLowerCase().indexOf("jpg") > -1 ||
          val.file.name.toLowerCase().indexOf("png") > -1 ||
          val.file.name.toLowerCase().indexOf("jpeg") > -1
        )
      ) {
        loading.close();
        this.$notify({
          title: "暂不支持该文件类型",
          type: "warning",
        });

        return;
      }
      let file = val.file;

      let formData = new FormData();
      formData.append("file", file);

      this.$post("/common/upload", formData)
        .then((res) => {
          console.log(11111);
          loading.close();
          this.uploadImag[index].value = res.data.url;
          this.uploadImag[index].uploadFlag = true;
          for (const key in this.form) {
            if (key == this.uploadImag[index].key) {
              this.form[key] = this.uploadImag[index].value;
            }
          }
          console.log(this.form);
        })
        .catch((error) => {
          loading.close();
          console.log(error);
        });
    },
    // 附件上传
    annexUpload(val) {
      console.log(val);
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (
        !(
          val.file.name.toLowerCase().indexOf("mp4") > -1 ||
          val.file.name.toLowerCase().indexOf("jpg") > -1 ||
          val.file.name.toLowerCase().indexOf("png") > -1 ||
          val.file.name.toLowerCase().indexOf("jpeg") > -1
        )
      ) {
        loading.close();
        this.$notify({
          title: "暂不支持该文件类型",
          type: "warning",
        });

        return;
      }
      let file = val.file;
      let formData = new FormData();
      formData.append("file", file);

      this.$post("/common/upload", formData)
        .then((res) => {
          loading.close();
          if (this.fileList1.length < 5) {
            if (res.data.url.indexOf("mp4") > -1) {
              this.fileList1.push({
                type: "video",
                value: res.data.url,
              });
            } else {
              this.fileList1.push({
                type: "img",
                value: res.data.url,
              });
            }
          } else {
            this.$message.warning("最多只能传5个哦");
          }

          console.log(this.fileList1);
        })
        .catch((error) => {
          loading.close();
          console.log(error);
        });
    },
    // 附件文件删除
    deleteAnnex(item, index) {
      console.log(item, index, this.fileList1);
      this.fileList1.splice(index, 1);
    },
    //   预案名称、区域数据
    changetower(val, istr, select) {
      console.log(val, istr, select);
      this.units.map((item, index) => {
        if (item.tower === val) {
          select
            ? (this.perselect2 = item.ceng)
            : (this.select2 = item.tierList);
        }
      });
      console.log(this.select2);
    },
    changetier(val, clear) {},
    changeBaseSituationCheck(val) {
      console.log(val);
      this.baseSituationCheck = val;
    },
    getAllPeople() {
      // 全部电子预案人员
      let url = this.id
        ? "/planDrill/planDrill/assignedPersonByCompanyNotChoice?companyNum=" +
          this.c_num +
          "&id=" +
          this.id
        : "/planDrill/planDrill/assignedPersonByCompanyNotChoice?companyNum=" +
          this.c_num;
      this.$get(url).then((res) => {
        // console.log(res, "所有人");
        let dataNew = [];
        res.data.map((item) => {
          // console.log(res,'res');
          dataNew.push({
            key: item.id,
            label: item.name,
            organization: item.organization,
            teamLeader: item.teamLeader || 0,
            phone: item.phone,
          });
          // log(this.transferValue,'this.transferValue')
          this.transferValue.push(item.id);
        });
        console.log(dataNew,this.transferValue,'transferData');
        this.transferData = dataNew;
        this.transferCopyData = dataNew;
      });
    },
    planArea() {
      this.$get("/drillplan/planJianzhu/planArea/" + this.c_num).then((res) => {
        // console.log(res, 111);onSubmit
        this.units = res.data;
      });
    },

    onSubmit(exprot) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
        lock: true,
        text: "上传中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
          console.log(this.groupList, "this.groupList");
          let groupList = JSON.parse(JSON.stringify(this.groupList));
          groupList.forEach((item, index) => {
            if (item.child == null) {
            } else {
              item.child.map((i, t) => {
                //   console.log(i);
                item.child[t] = {
                  id: i.key || i.id,
                  name: i.label || i.name,
                  organization: i.organization,
                  teamLeader: i.teamLeader || 0,
                  phone: i.phone,
                };
              });
            }
          });
          console.log(groupList, "this.groupList1");
          for (let i in this.assignedPersonData) {
            groupList.forEach((item, index) => {
              if (i == item.key) {
                this.assignedPersonData[i] = item.child;
              }
            });
          }
          console.log(groupList, "this.groupList2");

          console.log(this.assignedPersonData);
          this.form.drillPerson = JSON.stringify(this.assignedPersonData);
          // 把附件的图片视频转换成后端想要的
          let adjunct = this.fileList1.map((item, index) => {
            return item.value;
          });
          adjunct = adjunct.join(",");
          this.form.attachment = adjunct;
          console.log(this.form);
          this.form.baseSituationCheck = this.baseSituationCheck.join(",");

          if (exprot) {
            
            const element = document.getElementById("screenshot"); // 替换为要截屏的元素的ID或选择器
            //  console.log(element);
            html2canvas(element).then((canvas) => {
              // 将Canvas转换为Base64编码
             const base64 = canvas.toDataURL("image/png");
              this.form.organizationalImg = base64;
            console.log(this.form.organizationalImg);

            this.$post("/planDrill/planDrill/planSaveSync", this.form).then(
              (res) => {
                loading.close()
                console.log(res, 11111111);
                if (res.code == 200) {
                  // this.$message.success("保存成功");
                  this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
                }
              }
            );
            });

            
          } else {
            console.log("保存");
            // this.save();
            // 把穿梭框里的数据转换成后端想要的格式

            this.$post("/planDrill/planDrill/addOrUpdateInfo", this.form).then(
              (res) => {
                loading.close()

                console.log(res);
                this.form.id = res.data.id;
                if (res.code == 200) {
                  // this.$message.success("保存成功");
                   this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
                }
              }
            );
          }
        } else {
          this.$message.warning("请输出必填项");
        }
      });
    },
    // 导出
    downLoad() {
      const loading = this.$loading({
        lock: true,
        text: "导出中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const element = document.getElementById("screenshot"); // 替换为要截屏的元素的ID或选择器
      console.log(element);
      html2canvas(element).then((canvas) => {
        // 将Canvas转换为Base64编码
        const base64 = canvas.toDataURL("image/png");
        // console.log(base64);
 this.downLoadWordCopy("/planDrill/planDrill/planExportWord", {
          id: this.$route.query.id,
          organizationalImg: base64,
        }, "post", (res) => {
          loading.close()
        // this.isDownLoad = false;
      });
  
      });

    },
 downLoadWordCopy(url, params, method, func) {
  if (method === 'get') {
    // 若还是get 处理传参 查询字符串
    let urlparams = url + '?';
    for (const propName of Object.keys(params)) {
      const value = params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              let subPart = encodeURIComponent(params) + '=';
              urlparams += subPart + encodeURIComponent(value[key]) + '&';
            }
          }
        } else {
          urlparams += part + encodeURIComponent(value) + "&";
        }
      }
    }
    urlparams = urlparams.slice(0, -1);
    url = urlparams;
  }
  url = baseUrl + url
  axios({
    method: method || 'post',
    url: url,
    responseType: 'blob',
    data: params,
    timeout:120000,
    headers: { 'Authorization': 'Bearer ' + this.getToken() }
  }).then(res => {
    this.resolveBlob(res, mimeMap.docx)
    if (func && typeof func == 'function')
      func()
  })

},
resolveBlob(res, mimeType, params) {
  const aLink = document.createElement('a')
  var blob = new Blob([res.data], { type: mimeType })
  var fileName = '预案'
  //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  // console.log(res,'111111');
  var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  var contentDisposition = res.headers['content-disposition']
  // console.log(contentDisposition);
  // decodeURI
  if (contentDisposition !== undefined) {
    contentDisposition = decodeURI(contentDisposition)
    console.log(contentDisposition)
    var result = patt.exec(contentDisposition)
    fileName = result[1]
    fileName = fileName.replace(/\"/g, '')
    fileName = decodeURI(fileName)
  }
  aLink.style.display = 'none'
  aLink.href = URL.createObjectURL(blob)
  aLink.setAttribute('download', fileName) // 设置下载文件名称
  document.body.appendChild(aLink)
  aLink.click()
  URL.revokeObjectURL(aLink.href);//清除引用
  document.body.removeChild(aLink);
},


  
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px !important;
  /* height: 148px; */
  /* cursor: pointer; */
  line-height: 146px;
  vertical-align: top;
}
.container-list {
  padding: 0 20px;
}
.tree {
  font-size: 18px;
}
.duty p {
  margin-top: 10px;
}
.perbutton {
  width: 120px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  margin: 0 10px 0 0;
}
.jiacu {
  font-size: 17px;
  //   font-weight: bold;
}
.editDel {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-transfer-panel__list{
  overflow: auto;
  // display: block;
  // flex-direction: column;
}
::v-deep .el-transfer-panel__list::-webkit-scrollbar{
  display: block!important;
  width: 10px;
  background: #ffffff;
}
::v-deep .el-transfer-panel__list::-webkit-scrollbar-thumb{
  display: block!important;
  width: 10px;
  background: #b3b3b3;
}
::v-deep .el-transfer-panel__filter{
  // display: flex;
}
::v-deep .el-input__inner{
  // width: 80%;
  margin-left: 0;
  // padding-bottom: 10px;
}
</style>
